var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Portal',{attrs:{"selector":"#v2-sidebar"}},[_c('div',{attrs:{"id":"v2-sidebar-container"}},[_c('div',{style:(_vm.buildStyle),attrs:{"id":"v2-sidebar-container-inner"}},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }